import React from 'react'
import { connect } from 'react-redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import PropTypes from 'prop-types'
import * as audioActions from '../../../../../Core/Game/AudioContainer/audio.actions'
import { bindActionCreators } from 'redux'

const TileButton = ({ action, disabled, icon, label, addHowlSound }) => (
  <div
    onClick={() => {
      !disabled && action()
      addHowlSound('button_click_icon')
    }}
    className={'btn--orange ' + (disabled ? 'disabled' : '')}
  >
    {icon ? <span className={icon}></span> : null}
    <FormattedMessage id={label} />
  </div>
)

const mapDispatchToProps = (dispatch) => ({
  addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
})

TileButton.propTypes = {
  action: PropTypes.func,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  label: PropTypes.string,
  addHowlSound: PropTypes.func,
}

export default connect(null, mapDispatchToProps)(injectIntl(TileButton))
